/** Per-question study record. `updatedAt` drives cross-device merging. */
export interface SyncedProgress {
  seen: number;
  correct: number;
  wrong: number;
  lastCorrect: boolean | null;
  /**
   * Recent attempts as "1"/"0", newest first — upstream's `answeredAll`.
   * A question counts as "fit for the test" once the two most recent
   * attempts were both correct, which is what drops it out of the
   * "30 new questions" pool. Older docs may not have it; treat as "".
   */
  recent?: string;
  updatedAt: number;
}

/** How much attempt history to keep. Upstream's rule only reads the first two. */
export const RECENT_LIMIT = 8;

/**
 * Upstream's "fit für die Prüfung" test: `answeredAll` padded with zeros,
 * fit when the first two characters are "11" (last two attempts correct).
 */
export function isFit(progress: SyncedProgress | undefined): boolean {
  return `${progress?.recent ?? ""}000`.slice(0, 2) === "11";
}

/** Marks are stored with a flag rather than removed, so unmarking syncs too. */
export interface SyncedMark {
  marked: boolean;
  updatedAt: number;
}

/** Everything that follows a user between devices. */
export interface SyncDoc {
  progress: Record<string, SyncedProgress>;
  marked: Record<string, SyncedMark>;
  /** Newest `updatedAt` anywhere in the document. */
  updatedAt: number;
}

export function emptyDoc(): SyncDoc {
  return { progress: {}, marked: {}, updatedAt: 0 };
}

export interface PublicUser {
  username: string;
}
